import * as React from 'react';
import { Select } from 'antd';

interface ICountyStateSelectProps {
    name: string;
    onChange: (e: any, country: GQL.ICountryState | undefined) => void;
    value: string | undefined;
    states: GQL.ICountryState[];
    style?: any;
}

export class CountyStateSelect extends React.PureComponent<ICountyStateSelectProps> {

    constructor(props: ICountyStateSelectProps) {
        super(props);
    
        this.onChange = this.onChange.bind(this);
      }

    public render() {
        const { states, style, value } = this.props;

        const state = states.find((s: GQL.ICountryState) => s.name === value);

        return(
            <Select
                key={`${this.props.name}:${states.map(s => s.name).join(':')}`} // key is needed to clear selection after changing states
                showSearch={true}
                value={state ? state.name : value}
                placeholder={states.length > 0 ? 'Choose state / county' : 'State / county not available'}
                style={...style}
                onChange={this.onChange}
            >
                {states && states.map(s => (
                    <Select.Option
                        key={s.name}
                        value={s.name}
                    >
                        {s.name}
                    </Select.Option>
                ))}
            </Select>
        );
    }

    private onChange(value: string) {
      const { states } = this.props;
  
      const state = states && states.find((s: GQL.ICountryState) => s.name === value);
  
      if (this.props.onChange) {
        this.props.onChange({
          target: {
            name: this.props.name,
            value,
          }
        }, state);
      }
    }
};


// WEBPACK FOOTER //
// ./src/components/Others/CountyStateSelect/CountyStateSelect.tsx